import { useParams } from "react-router-dom";

import { toGlobalId } from "lib/Relay";

export const useAssortmentId = () => {
  const { id } = useParams<{ id: string }>();
  if (!id) {
    throw Error("An id is required.");
  }
  return id;
};

export const useGlobalAssortmentId = () => {
  const assortmentId = useAssortmentId();
  return toGlobalId({ type: "Assortment", id: assortmentId });
};
